import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHeaders,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from './environment';
import { AuthService } from '@library/modules/auth';

import { RadiantHttpInterceptor, HttpCancelService } from '@library/common/http';

@Injectable()
export class CpHttpInterceptor extends RadiantHttpInterceptor {
   constructor(
      private auth: AuthService,
      cancelService: HttpCancelService,
   ) {
      super(cancelService);
   }

   origin(): string {
      return environment.origin;
   }

   lambda(): string {
      return environment.lambdaApi;
   }

   localLambda(): string {
      return environment.localLambdaApi;
   }

   get version(): string {
      return environment.version || '1.0.0';
   }

   headers( request: HttpRequest<any> ): Observable<HttpHeaders> {
      return this.auth.setAuthHeaders( request.headers ).pipe(
         map( headers => headers.set( 'app-version', this.version )),
      );
   }
}

export let httpInterceptor2 = {
   provide: HTTP_INTERCEPTORS,
   useClass: CpHttpInterceptor,
   multi: true
};
